module.exports = __webpack_public_path__ + "media/hallBgm.f885f04d.mp3";